// extracted by mini-css-extract-plugin
export default {"commonRoundedButtonLink":"QaRLI","commonRoundedButton":"SsQea","buttonSecondaryAlt":"FK3Oz SsQea"};